import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';
import { cn } from '@wwe-portal/ui/lib/lib';
import wweLogoWebp from '@wwe-portal/ui/assets/images/flagship/wwe-logo.webp';

export const EmptySlot = ({ type }: { type: OfferCardTypeEnum }) => {
  return (
    <div
      className={cn(
        'bg-back400 flex h-full w-full select-none flex-row items-center justify-center gap-1',
        {
          'flex-col': OfferCardTypeEnum.SINGLE3 === type,
        }
      )}
    >
      <div className="flex h-full flex-col justify-center gap-y-2 space-y-4 px-4 py-8">
        <img
          alt="logo"
          className="mx-auto max-w-[50px] text-center"
          draggable="false"
          src={wweLogoWebp}
        />
      </div>
    </div>
  );
};
